import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static targets = ["toggle", "fontSection", "textSection", "fontSelect", "textInput"]

  connect() {
    console.log("Engraving controller connected")
    this.fontCollapse = new Collapse(this.fontSectionTarget, { toggle: false })
    this.textCollapse = new Collapse(this.textSectionTarget, { toggle: false })
    this.isExpanded = false
  }

  toggleEngraving(event) {
    event.preventDefault()
    console.log("Toggle clicked, current state:", this.isExpanded)
    
    if (this.isExpanded) {
      // Collapse everything
      this.fontCollapse.hide()
      this.textCollapse.hide()
      this.toggleTarget.querySelector('span').innerHTML = '<i class="bi bi-plus-circle me-2"></i>Add Free Engraving'
      this.fontSelectTarget.value = ''
      this.textInputTarget.value = ''
      this.textInputTarget.disabled = true
      this.isExpanded = false
    } else {
      // Expand font section
      this.fontCollapse.show()
      this.toggleTarget.querySelector('span').innerHTML = '<i class="bi bi-dash-circle me-2"></i>Remove Engraving'
      this.isExpanded = true
    }
  }

  fontChanged() {
    console.log("Font changed:", this.fontSelectTarget.value)
    this.updateVisibility()
  }

  updateVisibility() {
    const fontSelected = this.fontSelectTarget.value !== '' && this.fontSelectTarget.value !== 'Choose a font...'
    
    if (fontSelected) {
      this.textCollapse.show()
      this.textInputTarget.disabled = false
    } else {
      this.textCollapse.hide()
      this.textInputTarget.disabled = true
      this.textInputTarget.value = ''
    }
  }

  preventEnter(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault()
      return false
    }
  }
}
